import { render, staticRenderFns } from "./Teams.vue?vue&type=template&id=421de71f&scoped=true&"
import script from "./Teams.vue?vue&type=script&lang=ts&"
export * from "./Teams.vue?vue&type=script&lang=ts&"
import style0 from "./Teams.vue?vue&type=style&index=0&id=421de71f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421de71f",
  null
  
)

export default component.exports